/**
 * Utility method to return a default value when the value passed is nullish (undefined or null)
 *
 * This allows us to easily add fallback values to the application without the need of added testing for coverage
 */
export const getValueOrDefault = <T>(
  value: T | undefined | null,
  defaultValue: T
) => value ?? defaultValue;
